import { observable } from 'mobx';
import axios from 'axios';
import utils from '@utils/utils';

class store {
    //@observable sent = false;
    @observable error = false;

    sendFormField(formObj) {
        if(utils.getID() === null) {
            return;
        }
        
        return axios.post(utils.getMsgUrl('sendService'), {
            clientId: utils.getSendPrefix() + utils.getID(),
            event: "creditAppData",
            payload: formObj
        })
        /*.then((resp) => {
            this.sent = true;
        })
        .catch((error) => {
            this.error = true;
        })*/
    }
}
var BillingCreditStore = new store;
export default BillingCreditStore;


// WEBPACK FOOTER //
// ./src/js/stores/BillingCreditStore.js